import {React, Component, Container, _} from 'utils';
import { CampaignStore, Creators } from 'model';
import { debug } from 'util';

class AddCampaign extends Component {

	state = { validationError: null }

	static getStores() {
		return [CampaignStore];
	}

	static calculateState(state, props) {
		return CampaignStore.getState();
	}

	isFormValid(state) {
		const { name } = state;
		return !name || !name.trim();
	}

	submitForm() {
		const { name } = this.state;
		
		if (this.isFormValid(this.state)) {
			this.setState({ 
				validationError: _('Molimo vas unesite ime mape'),
			});
		} else {
			this.setState({ validationError: null }, () => {
				Creators.addCampaign(name);
			});
		}
	}

	handleChange(event) {
		Creators.campaignNameChanged(event.target.value);
	}

	handleCreate(event) {
		event.preventDefault();
		this.submitForm();
	}

	handleKeyPress(event) {
		if (event.keyCode === 13) {
			this.submitForm();
		}
	}

	render() {
		const { name, saving, validationError } = this.state;

		return <div>
			<form className="form-horizontal" onSubmit={(e) => this.handleCreate(e)}>
				<div className={`form-group ${validationError && "has-error"}`}>
					<div className="col-md-12">
						<label className="control-label" htmlFor="map-input">{validationError}</label>
						<input
							id="map-input"
							type="text"
							className="form-control"
							value={name}
							placeholder={_('Naziv mape')}
							onChange={(e) => this.handleChange(e)}
							onKeyDown={(e) => this.handleKeyPress(e)}
						/>
					</div>
				</div>
				<div>
					<button
						type="submit"
						className="btn btn-block btn-primary"
						style={{width: '100%'}}
						disabled={saving}
					>
						{saving ? (
							<i className="fa fa-circle-o-notch fa-spin fa-1x fa-fw"></i>
						) : (
							<span>{_('Spremi')}</span>
						)}
					</button>
				</div>
			</form>
		</div>;
	}
}

const addCampaign = Container.create(AddCampaign, { withProps: true });
export default addCampaign;


// WEBPACK FOOTER //
// ./src/modules/campaign/addCampaing.js